/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weight_LbsInputs */

const en_weight_lbs = /** @type {(inputs: Weight_LbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight (lbs)`)
};

const es_weight_lbs = /** @type {(inputs: Weight_LbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso (lbs)`)
};

/**
* | output |
* | --- |
* | "Weight (lbs)" |
*
* @param {Weight_LbsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const weight_lbs = /** @type {((inputs?: Weight_LbsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weight_LbsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_weight_lbs(inputs)
	return es_weight_lbs(inputs)
});